// Capitalizes the first letter of a text
function capitalizeFirstLetter(text) {
    return text.substring(0, 1).toUpperCase() + text.substring(1).toLowerCase();
}

// Global multi replace of string
function replaceString(text, find, replacement, ignoreCase = true) {
    const params = ignoreCase ? 'gi' : 'g';

    return text.replace(new RegExp(find, params), replacement);
}

function stringIsEmptyOrWhitespace(value) {
    return value === undefined || value === null || value.trim().length === 0;
}

function truncateString(text, maxLength, suffix = null) {

    if (stringIsEmptyOrWhitespace(text)) {
        return text;
    }

    const length = suffix !== null ? maxLength - suffix.length : maxLength;

    if (suffix !== null) {
        return text.substring(0, length) + suffix;
    }
    
    return text.substring(0, length);
}

export { capitalizeFirstLetter, replaceString, stringIsEmptyOrWhitespace, truncateString };